import React from 'react';
import BottomSheet from '../../../Components/Ui/BottomSheet'; // 공통 컴포넌트 경로 확인
import PinchZoom from '../../../Components/Ui/PinchZoom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Global from '../../../Services/Common/Global';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import DeleteDialog from '../../../Components/Dialog/DeleteDialog';
import { BackInfoActions } from '../../../Reducer/BackInfoReducer';
import { useBackStack } from '../../../Hooks/back/useBackStack';

export default function WorkInfoDetailBottomSheet({ workInfoDetail, DeleteLogic1 }) {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const { navigate } = useAppNavigate();
  // 바텀시트 열릴 때 최상단 요소로 포커스 이동 → 스크롤 최상단 보장
  const topFocusRef = React.useRef(null);

  const [isDeleteOpen, setIsDeleteOpen] = React.useState(false);
  const [beforeIndex, setBeforeIndex] = React.useState(0);
  const [afterIndex, setAfterIndex] = React.useState(0);

  const deleteTriggeredRef = React.useRef(false);

  // imgType이 PRE면 개선전, POST면 개선후
  const beforeImages = (workInfoDetail.images ?? [])
    .filter((item) => item?.imgType === 'PRE')
    .slice(0, 5);
  const afterImages = (workInfoDetail.images ?? [])
    .filter((item) => item?.imgType === 'POST')
    .slice(0, 5);

  // 스택형 뒤로가기로 변경: 참석 여부 팝업이 열려있을 때 차단
  useBackStack({
    type: 'dialog',
    enabled: isDeleteOpen, // 팝업이 열려있을 때만 가드 활성화
    onBack: () => {
      // 팝업이 열려있으면 뒤로가기 시 팝업만 닫음
      setIsDeleteOpen(false);
    },
  });

  const HandleDeleteClick = () => {
    // Dialog save 버튼 클릭 시 onClose이 함께 실행되므로, 닫힐 때 디테일 바텀시트도 닫을지 플래그로 구분
    deleteTriggeredRef.current = true;
    DeleteLogic1?.(workInfoDetail.nearMissSeq);
  };

  const HandleDeleteClose = () => {
    const shouldCloseDetailSheet = deleteTriggeredRef.current;
    deleteTriggeredRef.current = false;
    setIsDeleteOpen(false);
    if (shouldCloseDetailSheet) {
      dispatch(BottomSheetActions.CloseBottomSheet());
    }
  };

  const HandleEditClick = () => {
    // 서버 응답 기준 gubun(라벨) -> 라우트 파라미터 값으로 변환
    const gubunLabel = workInfoDetail?.gubun;
    const gubunKey =
      gubunLabel === 'risk' || gubunLabel === '위험요인 제보'
        ? 'risk'
        : gubunLabel === 'nearMiss' || gubunLabel === '아차사고 상황'
          ? 'nearMiss'
          : 'risk';

    // 바텀시트 닫고 수정 화면으로 이동
    dispatch(BottomSheetActions.CloseBottomSheet());
    navigate(`/M_WorkInfo/write/${gubunKey}`, {
      state: { detailItem: workInfoDetail },
    });
  };

  const HandleActionClick = () => {
    // id는 nearMissSeq 기준으로 라우팅
    const id = workInfoDetail?.nearMissSeq;
    if (!id) return;

    // 바텀시트 닫고 조치 화면으로 이동
    dispatch(BottomSheetActions.CloseBottomSheet());
    navigate(`/M_WorkInfo/action`, {
      state: { detailItem: workInfoDetail },
    });
  };

  // 헤더 영역 (isHeaderChildren={true} 로 전달될 내용)
  const headerContent = (
    <Box sx={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between', py: 2 }}>
      <span className={`rounded-md px-2.5 py-1 text-xs font-bold ${workInfoDetail.status === '완료' ? 'bg-green-100 text-green-600' : 'bg-orange-100 text-orange-600'
        }`}>
        {workInfoDetail.status || '진행중'}
      </span>
    </Box>
  );

  return (
    <>
      <BottomSheet
        isHeaderChildren={true}
        headerChildren={headerContent}
        initialFocusRef={topFocusRef}
      >
        {/* Scrollable Content Area */}
        <div className="flex flex-col gap-6 px-2 pb-4">

          {/* 2. 상세 정보 테이블 */}
          <div className="space-y-4 border-y border-gray-100 py-6">
            <div className="grid grid-cols-3 gap-2">
              <span className="text-sm font-medium text-gray-500">공정명</span>
              <span className="col-span-2 text-sm text-gray-900">
                {workInfoDetail.gongjongNm || "-"}
              </span>
            </div>
            <div className="grid grid-cols-3 gap-2">
              <span className="text-sm font-medium text-gray-500">발생일시</span>
              <span className="col-span-2 text-sm text-gray-900">
                {workInfoDetail.occurDate || "-"}
              </span>
            </div>
            <div className="grid grid-cols-3 gap-2">
              <span className="text-sm font-medium text-gray-500">장소</span>
              <span className="col-span-2 text-sm text-gray-900">
                {workInfoDetail.location || "-"}
              </span>
            </div>
            <div className="grid grid-cols-3 gap-2">
              <span className="text-sm font-medium text-gray-500">내용 및 대책</span>
              <span className="col-span-2 text-sm leading-relaxed text-gray-900">
                {workInfoDetail.content || "-"}
              </span>
            </div>
            <div className="grid grid-cols-3 gap-2">
              <span className="text-sm font-medium text-gray-500">조치결과</span>
              <span className="col-span-2 text-sm text-gray-900">
                {workInfoDetail.resultContent || "-"}
              </span>
            </div>
            <div className="grid grid-cols-3 gap-2">
              <span className="text-sm font-medium text-gray-500">조치일</span>
              <span className="col-span-2 text-sm text-gray-900">
                {workInfoDetail.resultDate || "-"}
              </span>
            </div>
          </div>

          {/* 3. 현장 사진 비교 섹션 */}
          <div>
            <h3 className="mb-3 text-sm font-bold text-gray-900 flex items-center gap-1">
              현장 사진 비교
            </h3>
            <div className="grid gap-3">
              {/* 개선전 */}
              <div className="relative aspect-square overflow-hidden rounded-2xl border border-gray-100 bg-gray-50 shadow-sm">
                {beforeImages.length > 0 ? (
                  <Swiper
                    modules={[Pagination]}
                    slidesPerView={1}
                    nested={true}
                    style={{ width: '100%', height: '100%' }}
                    onSlideChange={(swiper) => setBeforeIndex(swiper.realIndex)}
                  >
                    {beforeImages.map((img, idx) => (
                      <SwiperSlide key={img?.no ?? idx}>
                        <PinchZoom
                          componentWrapperStyle={{ width: '100%', height: '100%' }}
                          componentContentStyle={{ width: '100%', height: '100%' }}
                          contents={
                            <div
                              style={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                overflow: 'hidden',
                              }}
                            >
                              <img
                                src={`${Global.file.useUrl}files/${img?.imageFilePath.replace(/\\/g, '/')}`}
                                alt={`개선전-${idx + 1}`}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              />
                            </div>
                          }
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                ) : (
                  <div className="flex h-full items-center justify-center text-xs text-gray-300">
                    이미지 없음
                  </div>
                )}
                <div className="absolute bottom-2 left-2 z-10 pointer-events-none rounded-lg bg-red-500/90 px-2 py-1 text-[10px] font-black text-white uppercase tracking-wider">
                  개선전
                </div>
                {beforeImages.length > 0 && (
                  <div className="absolute bottom-2 right-3 z-10 pointer-events-none rounded-lg bg-black/60 px-2 py-1 text-[12px] font-bold text-white">
                    {beforeIndex + 1} / {beforeImages.length}
                  </div>
                )}
              </div>
              {/* 개선후 */}
              <div className="relative aspect-square overflow-hidden rounded-2xl border border-gray-100 bg-gray-50 shadow-sm">
                {afterImages.length > 0 ? (
                  <Swiper
                    modules={[Pagination]}
                    slidesPerView={1}
                    nested={true}
                    style={{ width: '100%', height: '100%' }}
                    onSlideChange={(swiper) => setAfterIndex(swiper.realIndex)}
                  >
                    {afterImages.map((img, idx) => (
                      <SwiperSlide key={img?.no ?? idx}>
                        <PinchZoom
                          componentWrapperStyle={{ width: '100%', height: '100%' }}
                          componentContentStyle={{ width: '100%', height: '100%' }}
                          contents={
                            <div
                              style={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                overflow: 'hidden',
                              }}
                            >
                              <img
                                src={`${Global.file.useUrl}files/${img?.imageFilePath.replace(/\\/g, '/')}`}
                                alt={`개선후-${idx + 1}`}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              />
                            </div>
                          }
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                ) : (
                  <div className="flex h-full items-center justify-center text-xs text-gray-300">
                    이미지 없음
                  </div>
                )}
                <div className="absolute bottom-2 left-2 z-10 pointer-events-none rounded-lg bg-green-500/90 px-2 py-1 text-[10px] font-black text-white uppercase tracking-wider">
                  개선후
                </div>
                {afterImages.length > 0 && (
                  <div className="absolute bottom-2 right-3 z-10 pointer-events-none rounded-lg bg-black/60 px-2 py-1 text-[12px] font-bold text-white">
                    {afterIndex + 1} / {afterImages.length}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* 5. 액션 버튼 (하단 고정 효과를 위해 pb 추가) */}
          <div className="flex flex-col gap-3">
            {userInfo.decUserId === workInfoDetail.discovererId && (
              <div className="grid grid-cols-2 gap-3">
                <button
                  onClick={HandleEditClick}
                  className="w-full rounded-2xl border border-blue-600 py-4 text-base font-bold text-blue-600 transition-all active:scale-[0.98] active:bg-blue-50"
                >
                  수정
                </button>
                <button
                  onClick={() => setIsDeleteOpen(true)}
                  className="w-full rounded-2xl border border-red-500 py-4 text-base font-bold text-red-500 transition-all active:scale-[0.98] active:bg-red-50"
                >
                  삭제
                </button>
              </div>
            )}
            {userInfo.authCd !== 'EMPLOYEE' && (
              <div>
                <button
                  onClick={HandleActionClick}
                  className="w-full rounded-2xl bg-blue-600 py-4 text-base font-bold text-white transition-all active:scale-[0.98] active:bg-blue-700"
                >
                  조치
                </button>
              </div>
            )}
          </div>
        </div>
        {/* DeleteDialog 컴포넌트를 BottomSheet 컴포넌트의 자식(children) 내부로 옮기면, 
        다이얼로그도 바텀시트의 포커스 범위 안에 포함되어 클릭 이벤트가 정상적으로 작동함 */}
        <DeleteDialog
          open={isDeleteOpen}
          onClose={HandleDeleteClose}
          onDelete={HandleDeleteClick} />
      </BottomSheet>
    </>
  );
}